<template>
  <div>
    <document-list :config="config" :isLoading="isLoading" :height="height"></document-list>
  </div>
</template>

<script>
import DocumentList from './DocumentList';
import loaderMixin from '@/mixins/loaderMixin';
export default {
  mixins: [loaderMixin],
  name: 'ToAcknowledge',
  props: {
    config: Object,
    height: Number, // optional height of this widget
  },
  components: {
    DocumentList,
  },
  created() {
    this.config.toAcknowledgeOnly = true;
  },
};
</script>

<style></style>
